import Approach from './Approach';

export default Approach;
